ALLOWED_CONTROLLER = 'people'
ALLOWED_ACTIONS = ['lookup_history']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  lookupHistoryTable = $('#lookup_history').dataTable({
    iDisplayLength: 50,
    order: [ [ 0, "asc" ] ]
  })
  console.log(lookupHistoryTable)

$(document).ready(ready)
